import { defineStore } from 'pinia'

export const useGeoLocationStore = defineStore('geoLocationStore', () => {
	const country = ref<string | undefined>(undefined)
	const city = ref<string | undefined>(undefined)
	const error = ref<any>(null)
	const cities = ref<any[]>([])
	const userStore = useUserStore()
	const { user, userCountry } = storeToRefs(userStore)

	const contentMarket = computed(() => {
		const countryValue = user.value ? userCountry.value : country.value
		return { market: countryValue }
	})

	const countryCode = computed(() => {
		const userStore = useUserStore()
		const code: string | undefined = userStore.user ? userStore.userCountry : country.value
		return code
	})

	const getCities = computed(() => {
		return cities.value
	})

	/**
	 * Set the country code to the geoLocationStore state
	 *
	 * @param {String | undefined} countryParam - The ISO 3166-1 alpha-2 country code to set
	 * @example setGeoLocation('FI')
	 */
	const setGeoLocation = (countryParam: string | undefined) => {
		country.value = countryParam
	}

	/**
	 * Set the country code to the geoLocationStore state
	 *
	 * @param {String | undefined} cityParam - City name in English
	 * @example setGeoLocation('Helsinki')
	 */
	const setGeoCity = (cityParam: string | undefined) => {
		city.value = cityParam
	}

	/**
	 * Set the error to the geoLocationStore state
	 *
	 * @param error - Error returned from the MaxMind GeoIP2 reader
	 */
	const setGeoLocationError = (error: any) => {
		error.value = error
	}

	const setCities = (citiesParam: any[]) => {
		cities.value = citiesParam
	}

	return {
		country,
		city,
		error,
		cities,
		contentMarket,
		setGeoLocation,
		setGeoCity,
		setGeoLocationError,
		setCities,
		getCities,
		countryCode
	}
})
